"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Label = _interopRequireDefault(require("../Label"));
var _Button = _interopRequireDefault(require("../Button"));
var _Code = _interopRequireDefault(require("./Code.style"));
var _dec, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let Code = (_dec = (0, _reactJss.default)(_Code.default), _dec(_class = class Code extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      copied: false
    };
    this.source = props.forwardRef || _react.default.createRef();
    this.copy = this.copy.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  copy(e) {
    const {
      onCopy,
      visibility
    } = this.props;
    if (!this._isMounted || visibility === 'disabled') return;
    if (onCopy) {
      onCopy(e);
      return;
    }
    let range;
    let selection;
    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(this.source.current);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(this.source.current);
      selection.removeAllRanges();
      selection.addRange(range);
    }
    document.execCommand('copy');
    this.setState({
      copied: true
    });
    setTimeout(() => {
      if (!this._isMounted) return;
      this.setState({
        copied: false
      });
    }, 2000);
  }
  render() {
    const {
      classes,
      className,
      id,
      visibility,
      value,
      label,
      buttonLabel,
      dataTestId
    } = this.props;
    const coClasses = (0, _clsx.default)(className, classes.code, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: coClasses,
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: classes.label,
      value: label
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.source
    }, /*#__PURE__*/_react.default.createElement("pre", {
      className: classes.pre,
      ref: this.source
    }, /*#__PURE__*/_react.default.createElement("code", {
      className: classes.value
    }, value)), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: classes.btn,
      size: "small",
      label: buttonLabel,
      onClick: this.copy,
      icon: this.state.copied ? 'check' : null,
      dataTestId: dataTestId ? `${dataTestId}-copy-button` : undefined
    })));
  }
}) || _class);
Code.defaultProps = {
  visibility: 'visible',
  buttonLabel: 'Copy'
};
var _default = exports.default = Code;